import React, { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useReveal } from '../Components/Fx/useReveal';

const SubmitPage = () => {
   const [loading, setLoading] = useState(false);
   const [sent, setSent] = useState(false);
   const { register, handleSubmit, reset } = useForm();
   const scope = useRef<HTMLDivElement>(null);
   useReveal(scope);

   const onSubmit = data => {
      setLoading(true);
      axios
         .post(`${process.env.REACT_APP_API}/submit`, data)
         .then(result => {
            if (result.data) {
               setSent(true);
               reset();
            }
         })
         .catch(err => console.log('something went wrong: ', err))
         .finally(() => setLoading(false));
   };

   return (
      <div ref={scope} className="page grid grid-cols-1 gap-12 md:grid-cols-12">
         <div className="md:col-span-4">
            <p className="text-lg leading-relaxed text-bone-muted" data-reveal>
               Know of an event that is missing from our database? Submit it below and, once reviewed, we'll add it to
               the archive.
            </p>
         </div>

         <form onSubmit={handleSubmit(onSubmit)} className="space-y-10 md:col-span-7 md:col-start-6">
            {sent && (
               <div className="chip-signal w-full justify-center py-3" role="status">
                  Your submission has been saved and is under review.
               </div>
            )}

            <label className="block" data-reveal>
               <span className="eyebrow">01 — Title</span>
               <input type="text" {...register('title', { required: true })} className="input" placeholder="What happened?" />
            </label>

            <label className="block" data-reveal>
               <span className="eyebrow">02 — Who was involved?</span>
               <input
                  type="text"
                  {...register('entities')}
                  className="input"
                  placeholder="Corporations, officials, public figures…"
               />
            </label>

            <label className="block" data-reveal>
               <span className="eyebrow">03 — Summary</span>
               <textarea
                  rows={5}
                  {...register('summary', { required: true })}
                  className="input resize-none"
                  placeholder="Tell us what you know, with sources if possible."
               />
            </label>

            <div className="flex justify-end gap-3" data-reveal>
               <Link to="../" className="button-ghost">
                  Cancel
               </Link>
               <button type="submit" disabled={loading} className="button">
                  {loading ? 'Sending…' : 'Submit case'}
               </button>
            </div>
         </form>
      </div>
   );
};

export default SubmitPage;
